import { CourseMenteesPanel } from '../components/course-mentees-panel';

export default class CourseMenteesFlyoutCtrl {
  /* @ngInject */
  constructor($scope) {
    $scope.CourseMenteesPanel = CourseMenteesPanel;
  }
}
